import axios from "axios";
import Instense from "./Axios-config";
import ReduxStore from "../../Redux/Store/IndexStore";


    export class UserService {


        public static GetUserMaster = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
           
            request.tenantid = tenantID;
            const url = `/User/GetUserData`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };


          public static GetRoleData = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
             
            request.tenantid = tenantID;
            const url = `/User/GetRoleDataNew`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              ReduxStore.dispatch({
                type: "SET_PERMISSION",
                payload: result,
              });
        
              return result;
            });
          };


          public static GetUserDataByUserid = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
             
            request.tenantid = tenantID;
            const url = `/User/GetUserDataByUserid`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };


          public static SaveUserData = async (request: any): Promise<any> => {
            // debugger;
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            let userName = storage === null ? "" : (storage.userName as any);
           
            request.TenantID = tenantID;
            request.UserName = userName;
            const url = `/User/SaveUserData `;
            return Instense.post(url, request).then((response) => {
              // debugger;
                let result = response.data.result as any[];
                return result;
            });
          };

          public static GetUserTimesheets = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            request.TenantId = tenantID;
            const url = `/User/GetUserTimesheets`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };

           public static GetExportData = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            request.TenantID = tenantID;
            const url = `/User/GetExportedDate`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };

           public static DeExportData = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            request.tenantid = tenantID;
            const url = `/User/DeExportedDate`;
            return Instense.delete(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };

          public static GetPayrollDetails = async (request: any): Promise<any | null> => {
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            request.TenantId = tenantID;
            const url = `/User/GetPayrollDetails`;
            return Instense.get(url, { params: request }).then((response) => {
              let result = response.data.result as any;
              return result;
            });
          };
          
          public static UpdateUserTimesheets = async (request: any): Promise<any> => {
            // debugger;
            // let storage = JSON.parse(localStorage.getItem("storage")!);
            // let tenantID = storage === null ? 0 : (storage.tenantID as any);
            // request.TenantID = tenantID;
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            const url = `/User/UpdateUserTimesheets `;
            return Instense.post(url, request).then((response) => {
              // debugger;
                let result = response.data.result as any[];
                return result;
            });
          };

             public static GetCimmpleFormat = async (request: any): Promise<any> => {
            // debugger;
            let storage = JSON.parse(localStorage.getItem("storage")!);
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            request.tenantid = tenantID;
            const raw = localStorage.getItem("locationId");
            const locationId = raw === null ? 0 : Number(raw) ;
            
            request.locationId = locationId;
            const url = `/User/GetCimmpleFormat `;
            return Instense.post(url, request).then((response) => {
              // debugger;
                let result = response.data.result as any[];
                return result;
            });
          };

    }